<template>
    <form @submit.prevent>
        <template v-if="$USER_LOGIN.get().isShippop">
            <h6 class="heading-small text-muted mb-4">ระดับการประเมินร้าน</h6>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> เลือกระดับการประเมินร้าน 
                            <i class="fas fa-exclamation-circle fa-xs text-muted" style="cursor: pointer;" 
                                v-b-tooltip title="
                                Tier 1 = คะแนนร้านสูงสุด
                                Tier 2 = คะแนนร้านสูง
                                Tier 3 = คะแนนร้านปานกลาง
                                Tier 4 = คะแนนร้านต่ำสุด">
                            </i>
                        </label>
                        <b-form-select :options="tierShop" v-model="images.tierShop">
                            <template v-slot:first>
                            <option :value="null || ''" disabled>{{'กรุณาเลือกระดับการประเมินร้าน'}}</option>
                            </template>
                        </b-form-select>
                    </div>
                </div>
            </div>
            <hr class="my-4" />
        </template>
        <h6 class="heading-small text-muted mb-4">อัพโหลดรูปหน้าร้าน</h6>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> อัพโหลดรูปหน้าร้าน
                        <a href="#" class="px-2" @click="openModalExample('frontArea')">คลิกดูตัวอย่าง</a>
                    </label>
                    <b-form-file multiple 
                        :state="($v.images.frontArea.$error) ? false : null"
                        :file-name-formatter="formatFrontArea" 
                        @change="uploadImage($event , 'frontArea')" 
                        placeholder="กรุณาอัพโหลดรูป (3-4 รูป)" 
                        accept=".jpg, .png">
                    </b-form-file>
                    <div class="row pt-4">
                        <div class="col-12 col-lg-6 col-xl-3 mb-3"
                            v-for="(image , index) in images.frontArea"
                            :key="index"
                        >
                            <BranceCardImage
                                :imagesFile="image"
                                :index="index"
                                @deleteImage="deleteImage(index , 'frontArea')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">อัพโหลดรูปสภาพแวดล้อมหน้าร้าน</h6>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> อัพโหลดรูปสภาพแวดล้อมหน้าร้าน เช่น ข้างๆร้าน บริเวณข้างนอกร้าน
                        <a href="#" class="px-2" @click="openModalExample('environmentArea')">คลิกดูตัวอย่าง</a>
                    </label>
                    <b-form-file multiple 
                        :state="($v.images.environmentArea.$error) ? false : null"
                        :file-name-formatter="formatEnvironmentArea" 
                        @change="uploadImage($event , 'environmentArea')" 
                        placeholder="กรุณาอัพโหลดรูป (3-4 รูป)" 
                        accept=".jpg, .png"
                    ></b-form-file>
                    <div class="row pt-4">
                        <div class="col-12 col-lg-6 col-xl-3 mb-3"
                            v-for="(image , index) in images.environmentArea"
                            :key="index"
                        >
                            <BranceCardImage
                                :imagesFile="image"
                                :index="index"
                                @deleteImage="deleteImage(index , 'environmentArea')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">อัพโหลดรูปพื้นที่ในร้าน</h6>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> อัพโหลดรูปพื้นที่ในร้าน
                        <a href="#" class="px-2" @click="openModalExample('shopArea')">คลิกดูตัวอย่าง</a>
                    </label>
                    <b-form-file multiple 
                        :state="($v.images.shopArea.$error) ? false : null"
                        :file-name-formatter="formatShopArea" 
                        @change="uploadImage($event , 'shopArea')" 
                        placeholder="กรุณาอัพโหลดรูป (3-4 รูป)" 
                        accept=".jpg, .png"
                    ></b-form-file>
                    <div class="row pt-4">
                        <div class="col-12 col-lg-6 col-xl-3 mb-3"
                            v-for="(image , index) in images.shopArea"
                            :key="index"
                        >
                            <BranceCardImage
                                :imagesFile="image"
                                :index="index"
                                @deleteImage="deleteImage(index , 'shopArea')"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>
                        อัพโหลดรูปพื้นที่เก็บของ (หากมี)
                        <a href="#" class="px-2" @click="openModalExample('storageSpace')">คลิกดูตัวอย่าง</a>
                    </label>
                    <b-form-file multiple 
                        :file-name-formatter="formatStorageSpace" 
                        @change="uploadImage($event , 'storageSpace')" 
                        placeholder="กรุณาอัพโหลดรูป (3-4 รูป)" 
                        accept=".jpg, .png"
                    ></b-form-file>
                    <div class="row pt-4">
                        <div class="col-12 col-lg-6 col-xl-3 mb-3"
                            v-for="(image , index) in images.storageSpace"
                            :key="index"
                        >
                            <BranceCardImage
                                :imagesFile="image"
                                :index="index"
                                @deleteImage="deleteImage(index , 'storageSpace')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="$USER_LOGIN.get().isAdmin">
            <hr class="my-4" />
            <div class="mt-4 w-100 text-right">
                <b-button variant="secondary" @click="resetForm()">กรอกใหม่</b-button>
                <b-button type="submit" variant="info" @click="createOrUpdateImages()">บันทึก</b-button>
            </div>
        </template>
        <ModalImageExample
            :imageExample="imageExample"
        />
    </form>
</template>

<script>
import Compressor from 'compressorjs'
import BranceCardImage from '@/components/custom/branceNew/BranceCardImage'
import ModalImageExample from '@/components/custom/branceNew/ModalImageExample'
import {
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators"
import validatePop from "@/plugins/validatePop.js"
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
export default {
    name:"BranceImages",
    props: {
        submittEdit: Boolean,
        images: Object,
    },
    data(){
        return{
            imageExample:{
                show:false,
                nameInput:""
            },
            tierShop:[
                { value: "1", text: "Tier 1"},
                { value: "2", text: "Tier 2" },
                { value: "3", text: "Tier 3" },
                { value: "4", text: "Tier 4" }
            ],
        }
    },
    validations: {
        images:{
            frontArea: { required, minLength: minLength(3), maxLength: maxLength(4) },
            environmentArea: { required, minLength: minLength(3), maxLength: maxLength(4) },
            shopArea: { required, minLength: minLength(3), maxLength: maxLength(4) },
        }
    },
    components:{
        BranceCardImage,
        ModalImageExample
    },
    methods: {
        createOrUpdateImages(){
            this.$emit('update:submittEdit', true);
            this.$v.images.$touch();
            if (this.$v.images.$invalid) {
                return false
            }
            this.$emit('handleLoader');
            this.$http
                .post(
                this.$API_URL + "/shop/shop/detail",
                {
                    type: "images",
                    image_shop: JSON.stringify({
                        front_area: this.images.frontArea,
                        environment_area: this.images.environmentArea,
                        shop_area: this.images.shopArea,
                        storage_space: this.images.storageSpace
                    })
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop( res )
                    this.$emit('handleLoader');
                    if( !checkError.status ){
                        showErrorModal( checkError.msg )
                        return false
                    }
                    showSuccessModal('บันทึกข้อมูลรูปร้านสำเร็จ')
                })
                .catch(error => {
                });
        },
        formatFrontArea() {
            return this.images.frontArea.length === 0 ? 'กรุณาอัพโหลดรูป (3-4 รูป)' : `${this.images.frontArea.length} ไฟล์`
        },
        formatEnvironmentArea(){
            return this.images.environmentArea.length === 0 ? 'กรุณาอัพโหลดรูป (3-4 รูป)' : `${this.images.environmentArea.length} ไฟล์`
        },
        formatShopArea(){
            return this.images.shopArea.length === 0 ? 'กรุณาอัพโหลดรูป (3-4 รูป)' : `${this.images.shopArea.length} ไฟล์`
        },
        formatStorageSpace(){
            return this.images.storageSpace.length === 0 ? 'กรุณาอัพโหลดรูป (3-4 รูป)' : `${this.images.storageSpace.length} ไฟล์`
        },
        openModalExample(nameInput){
            this.imageExample.show = true
            this.imageExample.nameInput = nameInput
        },
        uploadImage(e , nameInput) {
            this.images.editImage = true;
            if (e.target.files.length < 1) return false;
            let SELF = this
            Array.from(e.target.files).forEach(image => {
                new Compressor(image, {
                    quality: 0.6,
                    maxHeight: 1024,
                    maxHeight: 1024,
                    success(result) {
                        const reader = new FileReader();
                        reader.readAsDataURL(result)
                        reader.onload = e => {
                            SELF.images[nameInput].push({
                                name:image.name,
                                preview:e.target.result,
                            });
                        }
                    }
                })
            });  
        },
        deleteImage(index , nameInput){
            this.images.editImage = true;
            this.images[nameInput].splice( index , 1)
        },
        resetForm(){
            Object.keys(this.images).forEach(key => {
                if(['environmentArea','frontArea','shopArea','storageSpace'].includes(key)){
                    this.images[key] = [];
                }
            });
        }
    }
}
</script>

<style>

</style>